import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";

import messagesDescription from "components/messagesDescription";
import { clearSystemMessage } from "../actions/systemMessageActions";

const NotFoundGeneric = () => (
  <article className="card card--alert">
    <section>
      <p>
        <FormattedMessage {...messagesDescription.nofileDescription} />
      </p>
    </section>
  </article>
);

class NotFoundCustom extends Component {
  constructor(props) {
    super(props);
    const sysmsg = props.systemMessage || { data: {} };
    this.state = {
      msg: sysmsg.msg || "",
      msgType: sysmsg.msgType || "",
      msgLangId: sysmsg.data.msgLangId || "",
      resource: sysmsg.data.resource || "",
    };
  }

  componentWillReceiveProps(nextProps) {
    const nxtMsg = nextProps.systemMessage;
    if (nxtMsg.msg !== this.props.systemMessage.msg && nxtMsg.msg.length > 0) {
      this.setState({
        msg: nxtMsg.msg,
        msgType: nxtMsg.msgType,
        data: nxtMsg.data,
        resource: nxtMsg.data.resource,
      });
    }
  }

  componentDidMount() {
    this.props.clearSystemMessage();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.msg.length > 0;
  }

  render() {
    const { msg, msgType, msgLangId, resource } = this.state;
    const { clearSystemMessage, intl } = this.props;

    let strmsg = msg;
    if ((msgLangId || "").length > 0) {
      strmsg =
        intl.formatMessage(messagesDescription[msgLangId]) + " " + resource;
    } else {
      strmsg = <FormattedMessage {...messagesDescription.nofileDescription} />;
    }

    return (
      <article className="card card--alert">
        <section>
          <p>{strmsg}</p>
          {this.props.children}
        </section>
      </article>
    );
  }
}

class NotFound extends Component {
  render() {
    if (
      typeof this.props.systemMessage === "undefined" ||
      !this.props.location.pathname.endsWith("/404")
    )
      return <NotFoundGeneric />;
    else return <NotFoundCustom {...this.props} />;
  }
}

const mapStateToProps = ({ systemMessage }) => ({
  systemMessage,
});

const mapDispatchToProps = {
  clearSystemMessage,
};

const NotFoundContainer = injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(NotFound)
);

export { NotFound, NotFoundContainer };



// WEBPACK FOOTER //
// ./components/notFound.jsx